import {
  Card,
  FormControlLabel,
  ListItem,
  ListItemIcon,
  ListItemText,
  Switch
} from "@material-ui/core";
import CardTitle from "@saleor/components/CardTitle";
import Checkbox from "@saleor/components/Checkbox";
import {
  Coupons_SubPermission_Enums,
  handleSubpermissionsArrayToggle
} from "@saleor/permissionGroups/utils/utils";
import React from "react";
import { useIntl } from "react-intl";

export interface CouponsSubPermissionGroupDialogProps {
  data: {
    permissions: string[];
  };

  onChange: (event: React.ChangeEvent<any>, cb?: () => void) => void;
}
const CouponsSubPermissionGroupDialog: React.FC<CouponsSubPermissionGroupDialogProps> = ({
  onChange,
  data
}) => {
  const intl = useIntl();
  const userCouponAccess = data?.permissions;
  const enumCouponAccessArray: string[] = Object.values(
    Coupons_SubPermission_Enums
  );
  const userCouponAccessHasAllPermission = enumCouponAccessArray.every(
    permission => userCouponAccess.includes(permission)
  );

  const formatAccessEnumLabel = (str: string) => {
    switch (str) {
      case "ADD_COUPON":
        return "Create Coupon";
      case "CHANGE_COUPON":
        return "Update Coupon";
      case "VIEW_COUPON_REDEMPTION":
        return "View Coupon Codes";
      case "FEATURE_COUPONS":
        return "Manage Coupon Featuring";
      case "MANAGE_COUPON_USAGE_LIMIT":
        return "Set Coupon Usage Limit for Mall Deals";
      case "MANAGE_COUPON_USAGE_LIMIT_EVENTS":
        return "Set Coupon Usage Limit for Mall Events";
    }
  };

  const handleAllowAll = () => {
    if (userCouponAccessHasAllPermission) {
      onChange({
        target: {
          name: "permissions",
          value: handleSubpermissionsArrayToggle(
            "remove",
            enumCouponAccessArray,
            userCouponAccess
          )
        }
      } as any);
    } else {
      onChange({
        target: {
          name: "permissions",
          value: handleSubpermissionsArrayToggle(
            "add",
            enumCouponAccessArray,
            userCouponAccess
          )
        }
      } as any);
    }
  };

  const handleSubPermissionToggle = (key, value) => () => {
    onChange({
      target: {
        name: "permissions",
        value: !value
          ? data.permissions.concat([key])
          : data.permissions.filter(perm => perm !== key)
      }
    } as any);
  };

  return (
    <Card>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Access",
          description: "header"
        })}
        toolbar={
          <FormControlLabel
            label="Allow All Access"
            control={
              <Checkbox
                id="allowAllCouponPermissionCheckBox"
                name="allowedAll"
                checked={userCouponAccessHasAllPermission}
                onChange={handleAllowAll}
              />
            }
          />
        }
      />
      {enumCouponAccessArray.map((subpermission, index) => (
        <ListItem key={index}>
          <ListItemText
            id={`couponPermissionToggle${index}`}
            primary={formatAccessEnumLabel(subpermission)}
          />
          <ListItemIcon>
            <Switch
              color="primary"
              onClick={handleSubPermissionToggle(
                subpermission,
                userCouponAccess.includes(subpermission)
              )}
              checked={userCouponAccess.includes(subpermission)}
              name={subpermission}
              id={`couponPermissionToggle${index}`}
            />
          </ListItemIcon>
        </ListItem>
      ))}
    </Card>
  );
};
CouponsSubPermissionGroupDialog.displayName = "CouponsSubPermissionGroupDialog";
export default CouponsSubPermissionGroupDialog;
